<template>
  <div class="encumbrance">
    <div class="encumbrance-header">
      <h3>Обременение {{ eindex + 1 }}</h3>
      <button class="btn" @click="closeButton">
        <img src="@img/close.svg" alt="">
        Скрыть
      </button>
    </div>
    <vue-custom-scrollbar :settings="settings" class="scroll-encumbrance">
      <div class="encumbrance-block" >
        <div class="encumbrance-block-item">
          <p>Тип обременения</p>
          <input v-model="encumbrance.encumbrance.encumbranceType" @click="toggleEncumbranceTree" class="form-control" type="text">
          <!-- <p>{{ encObj.name }}</p> -->
        </div>
        <div class="encumbrance-block-item">
          <p>Описание</p>
          <input v-model="encumbrance.encumbrance.name" class="form-control" type="text">
          <!-- <p>{{ encObj.encumbranceType.text }}</p> -->
        </div>
        <div class="encumbrance-block-item">
          <p>Номер</p>
          <input v-model="encumbrance.encumbrance.regNumber" class="form-control" type="text">
          <!-- <p>{{ encObj.regNumber }}</p> -->
        </div>
        <div class="encumbrance-block-item">
          <p>Дата регистрации</p>
          <input v-model="encumbrance.encumbrance.regDate" class="form-control" type="date">
          <!-- <p>{{ encObj.regDate }}</p> -->
        </div>
        <div class="encumbrance-block-item">
          <p>Дата начала</p>
          <input v-model="encumbrance.encumbrance.dateStarted" class="form-control" type="date">
          <!-- <p>{{ encObj.dateStarted }}</p> -->
        </div>
        <div class="encumbrance-block-item">
          <p>Дата окончания</p>
          <input v-model="encumbrance.encumbrance.dateStopped" class="form-control" type="date">
          <!-- <p>{{ encObj.dateStopped }}</p> -->
        </div>

        <div class="encumbrance-block-item">
          <p>Документы</p>
          <!-- <button @click="qwe()">Test</button> -->
          <DocWithTypeLoader @setDocumentsWithType="setDocumentsWithType($event)" :initData="encumbranceDocInitData"/>
        </div>

        <div class="encumbrance-block-item">
          <p>Владельцы обременения</p>
          <div class="owners-table-preview">
            <!-- <button @click="qwe()">qwe</button> -->
            <div class="owners-table-row">
              <span>Тип</span>
              <span>Владелец</span>
            </div>
            <div class="owners-table-row" v-for="(encItem, index) in encumbrance.encumbranceOwner" :key="index">
              <span v-if="encItem.typeOfOwner !== null && encItem.typeOfOwner !== undefined">{{ encItem.typeOfOwner.code_sp }}</span>
              <span v-if="encItem.typeOfOwner !== null && encItem.typeOfOwner !== undefined">{{ encItem.name }}</span>
            </div>
          </div>
          <button @click="isSelectOwner = true" class="btn accent-btn select-owners-btn">Выбрать</button>
          <transition name="popup-opacity">
            <PopupVue
              v-show="isSelectOwner"
              @closePopup="closePopup()"
              class="popup-select-owner"
            >
              <template #content>
                <SelectOwnerVue @closePopup="closePopup()" @changeOwners="changeOwners($event)" :initData="encOwnerInitData"/>
              </template>
            </PopupVue>
          </transition>
          <!-- <SelectOwnerVue :initData="encOwnerInitData" @changeOwners="changeOwners($event)"/> -->
        </div>
      </div>
    </vue-custom-scrollbar>
    <PopupVue v-if="showTree" @closePopup="showTree = false">
      <template #content>
        <h2 style="margin-bottom: 15px">Выбрать тип обременения</h2>
        <TreeComponent :initOnMount="true" :inputData="encumbranceTypeTreeList" @setSelected="setSelected($event)" />
      </template>
    </PopupVue>
  </div>
</template>

<script>
import DocWithTypeLoader from './DocWithTypeLoader.vue'
import PopupVue from './PopupVue.vue'
import SelectOwnerVue from './SelectOwnerVue.vue'
import ToggleComponentVue from './ToggleComponentVue'
import TreeComponent from './tree/TreeComponent.vue'

export default {
  props: ['encObj', 'eindex', 'inputData'],
  components: {
    ToggleComponentVue,
    PopupVue,
    TreeComponent,
    DocWithTypeLoader,
    SelectOwnerVue
  },
  data () {
    return {
      encumbranceDocInitData: null,
      encOwnerInitData: null,
      showTree: false,
      isSelectOwner: false,
      settings: {
        suppressScrollX: true
      },
      encumbrance: {
        restrictNumber: null,
        encumbrance: {
          restrictNumber: null,
          encumbranceTypeCode: null,
          encumbranceType: null,
          name: null,
          regNumber: null,
          regDate: null,
          dateStarted: null,
          dateStopped: null,
          term: null
        },
        documents: [],
        encumbranceOwner: []
      }
    }
  },
  computed: {
    encumbranceTypeTreeList () {
      return this.createTreeListMix(this.$store.getters.ECUMBRANCE_TYPE_LIST)
    }
  },
  mounted () {
    /*
      На первом компоненте(в v-for родителя) данные приходят undefined т.к. хоть одно обременение
      по дефолту есть(изначально это компонент создания), а потом становятся варидными данными, последующие[компоненты]
      в свою очередь сразу заполненны данными. По этому необходимо и в mounted(помимо watch) добавить парс данных
    */
    if (this.inputData !== undefined && this.inputData !== null) {
      this.parseEncumbrance(this.inputData)
    }
  },
  watch: {
    encumbrance: {
      handler: function (newVal) {
        this.$emit('changeEncumbrance', newVal)
      },
      deep: true
    },
    inputData (newVal) {
      this.parseEncumbrance(newVal)
    }
  },
  methods: {
    qwe () {
      // console.log(this.inputData)
      console.log(this.encumbrance)
    },
    closePopup () {
      this.isSelectOwner = false
    },
    parseEncumbrance (encumbrance) {
      // console.log('encumbrance', encumbrance)
      if (encumbrance === undefined) {
        return
      }
      this.encumbrance.encumbrance.regNumber = encumbrance.regNumber
      this.encumbrance.encumbrance.dateStarted = encumbrance.dateStarted
      this.encumbrance.encumbrance.dateStopped = encumbrance.dateStopped
      this.encumbrance.encumbrance.regDate = encumbrance.regDate
      this.encumbrance.encumbrance.name = encumbrance.name

      if (encumbrance.encumbranceType !== null) {
        this.encumbrance.encumbrance.encumbranceTypeCode = encumbrance.encumbranceType.code
        this.encumbrance.encumbrance.encumbranceType = encumbrance.encumbranceType.text
      }

      if (encumbrance.encumbranceOwnerSet !== null && encumbrance.encumbranceOwnerSet !== 'null' && encumbrance.encumbranceOwnerSet.edges.length > 0) {
        let owners = []
        encumbrance.encumbranceOwnerSet.edges.forEach(encOwnerEdge => {
          let _own = encOwnerEdge.node.owner
          let _ownType = _own.sp.code
          if (this.isPersonMix(_ownType)) {
            owners.push({
              typeOfOwner: {
                code_sp_code: _own.sp.code,
                code_sp: _own.sp.text
              },
              oid: _own.oid,
              id: _own.pk,
              location: {
                text: null
              },
              firstName: _own.person.firstName,
              lastName: _own.person.lastName,
              middleName: _own.person.middleName,
              name: _own.name
            })
          } else if (this.isOrganizationMix(_ownType)) {
            owners.push({
              typeOfOwner: {
                code_sp_code: _own.sp.code,
                code_sp: _own.sp.text
              },
              oid: _own.oid,
              id: _own.pk,
              location: {
                text: null
              },
              name: _own.organization.name,
              fullName: _own.organization.fullName,
              ogrn: _own.organization.ogrn
            })
            // _own.organizationSet.edges.forEach(org => {
            //   owners.push({
            //     typeOfOwner: {
            //       code_sp_code: _own.sp.code,
            //       code_sp: _own.sp.text
            //     },
            //     oid: _own.oid,
            //     location: {
            //       text: null
            //     },
            //     name: org.node.name,
            //     fullName: org.node.fullName,
            //     ogrn: org.node.ogrn
            //   })
            // })
          } else {
            owners.push({
              typeOfOwner: {
                code_sp_code: _own.sp.code,
                code_sp: _own.sp.text
              },
              oid: _own.oid,
              id: _own.pk,
              location: {
                text: null
              },
              name: _own.governance.name
            })
          }
        })
        // console.log('owners', owners)
        this.encOwnerInitData = owners
      }

      if (encumbrance.documentSet !== undefined && encumbrance.documentSet !== null && encumbrance.documentSet.edges.length > 0) {
        let encDocArr = []
        // console.log(encumbrance.documentSet)
        encumbrance.documentSet.edges.forEach(rightDocEdge => {
          let doc = {
            documentType: rightDocEdge.node.documentType.text,
            documentTypeCode: rightDocEdge.node.documentType.code,
            name: rightDocEdge.node.file,
            file: rightDocEdge.node.file,
            date: rightDocEdge.node.date,
            notes: rightDocEdge.node.notes,
            number: rightDocEdge.node.number,
            seria: rightDocEdge.node.seria
          }
          encDocArr.push(doc)
        })
        this.encumbranceDocInitData = encDocArr
        // console.log(this.encumbranceDocInitData)
      }
    },

    changeOwners (e) {
      // console.log(e)
      this.$set(this.encumbrance, 'encumbranceOwner', e)
    },

    setDocumentsWithType (e) {
      this.$set(this.encumbrance, 'documents', e)
    },

    setSelected (e) {
      this.encumbrance.encumbrance.encumbranceTypeCode = e.fullInfo[0].id
      this.encumbrance.encumbrance.encumbranceType = e.fullInfo[0].text
      this.showTree = false
    },

    toggleEncumbranceTree () {
      this.showTree = !this.showTree
    },

    closeButton () {
      this.$emit('closeEcumbrance', this.eindex)
    }
  }
}
</script>

<style lang="scss">
.encumbrance {
  position: absolute;
  padding: 30px 50px;
  top: 0;
  right: 0;
  height: 100%;
  width: 460px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      vertical-align: bottom;
    }
  }
  &-block {
    padding-right: 15px;
    &-item {
      margin-top: 25px;
      padding-bottom: 25px;
      border-bottom: 1px solid #e6e6e6;
      &:first-child {
        margin-top: 0;
      }
      h6 {
        font-size: 14px;
        margin-bottom: 10px;
      }
      p {
        margin-bottom: 10px!important;
      }
    }
  }
  .scroll-encumbrance {
    position: absolute;
    overflow: auto;
    top: 90px;
    left: 50px;
    right: 35px;
    display: flex;
    flex-direction: column;
    // width: 100%;
    height: calc(100% - 133px);
  }
}
.document {
  &-block {
    display: table;
    margin-top: 15px;
    &-item {
      display: table-row;
      &:last-child {
        h6,
        p {
          padding-bottom: 0;
        }
      }
      h6,
      p {
        display: table-cell;
        padding-bottom: 10px;
        font-size: 12px;
      }
      h6 {
        width: 105px;
        font-size: 12px;
        padding-right: 10px;
        text-align: right;
        font-weight: 400;
        color: #929292;
      }
    }
  }
}

.owner {
  &-block {
    &-item {
      margin-top: 20px;
      h6 {
        font-size: 12px;
        margin-bottom: 5px;
      }
      p {
        font-size: 12px;
      }
    }
  }
}

.organization-block,
.person-block,
.governance-block {
  padding-top: 25px;
  padding-bottom: 25px;
  border-bottom: 1px solid #e6e6e6;
  &:last-child {
    padding-bottom: 0;
    border: none
  }
}

.encumbrance-detail-edit-wrap {
  .form-control {
    height: 40px;
  }
  .popup-dialog {
    padding: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EncumbranceEditVue.vue